// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"1ff3b261","348":"bf56e992"}[chunkId] + ".chunk.css";
};